module.exports = __webpack_public_path__ + "static/img/specific_1.570475d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specific_1.png
// module id = elGe
// module chunks = 16